/* eslint-disable @typescript-eslint/no-unused-vars */
import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { LoaderState } from './loader';

@Injectable()
export class LoaderService {

  private loaderSubject = new Subject<LoaderState>();
  private apiLoaderVisible = false;
  private routeLoaderVisible = false;

  loaderState = this.loaderSubject.asObservable();

  show(type?: string) {
    if (type === 'route') {
      this.routeLoaderVisible = true;
    } else {
      this.apiLoaderVisible = true;
    }
    this.emitLoaderState();
  }

  hide(type?: string) {
    if (type === 'route') {
      this.routeLoaderVisible = false;
    } else {
      this.apiLoaderVisible = false;
    }
    this.emitLoaderState();
  }

  private emitLoaderState(): void {
    this.loaderSubject.next(<LoaderState>{
      show: this.apiLoaderVisible || this.routeLoaderVisible,
    });
  }
}
